<script>
  export let department = '';
  export let page = '';
</script>

<style lang="scss">
  @import './styles/theme.scss';
  .tooltip__content {
    h2 {
      @include fluid-font-size($fs-xsmall);
      color: $c-gray-2;
      white-space: nowrap;
    }
    p {
      @include fluid-font-size($fs-small);
      white-space: nowrap;
    }
  }
</style>

<div class="tooltip__content">
  <h2>Seite {page}</h2>
  <p>{department}</p>
  >
</div>
